import { useState } from "react";
import { useThreeDotsQuoteContext } from "@/main/components/shared/threeDotsQuote/contex";
import { Controls } from "@/main/services/constants/constantsControl";
import { getTranslateByKey, isShowControlByElementId, isOrderFromXnuupClaims } from "@/main/services/utils";
import { MenuItem } from "@mui/material";
import ModalClaimVouchers from "@/main/components/shared/modalClaimVouchers/modalClaimVouchers";

interface IThreeDotsQuoteViewVouchers {
	guidInsurer?: string | null;
	reportNumber?: string;
	orderNumber?: string;
	vehicleName?: string;
	quoteNumber?: string;
}

function ThreeDotsQuoteViewVouchers({
	guidInsurer,
	reportNumber,
	orderNumber,
	vehicleName,
	quoteNumber,
}: Readonly<IThreeDotsQuoteViewVouchers>) {
	const { setAnchorEl } = useThreeDotsQuoteContext();
	const [isModalOpen, setIsModalOpen] = useState(false);

	const hasPermission = isShowControlByElementId(Controls.IdViewVouchers);
	const isXnuupClaims = isOrderFromXnuupClaims(guidInsurer);

	const showViewVouchers = hasPermission && isXnuupClaims;

	function handleClickViewVouchers() {
		setIsModalOpen(true);
	}

	function handleCloseModal() {
		setIsModalOpen(false);
		setAnchorEl(null);
	}

	if (!showViewVouchers) return null;

	return (
		<>
			<MenuItem id="id-option-button-view-vouchers" onClick={handleClickViewVouchers}>
				{getTranslateByKey("control.viewVouchers")}
			</MenuItem>

			<ModalClaimVouchers
				isOpen={isModalOpen}
				onClose={handleCloseModal}
				reportNumber={reportNumber}
				orderNumber={orderNumber}
				vehicleName={vehicleName}
				guidInsurerCompany={guidInsurer ?? undefined}
				quoteNumber={quoteNumber}
			/>
		</>
	);
}

export { ThreeDotsQuoteViewVouchers };
